import Vue from 'vue'
import Page from '@/components/pdf-pages/qi'
import injectedCss from '!!raw-loader!@/components/pdf-pages/css/qi.css'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateQi = async ({ qi, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :qi="qi" />`,
      components: {
        'page': Page
      },
      data: () => ({
        qi
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss, injectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
